/* SIZESOFTX
=========================================================================================
* Descripción: Rutas del panel de soporte SizeSoftX
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/09/2026 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import React from "react";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import RequireMaster, { RequireRole } from "./guard/RequireMaster";
import MasterLayout from "./layout/MasterLayout";
import LoginPage from "./pages/LoginPage";
import ResumenPage from "./pages/ResumenPage";
import TenantsPage from "./pages/TenantsPage";
import EstadoCuentaPage from "./pages/EstadoCuentaPage";
import ComunicacionesPage from "./pages/ComunicacionesPage";
import GrafanaPage from "./pages/GrafanaPage";
import BitacoraPage from "./pages/BitacoraPage";
import UsuariosPage from "./pages/UsuariosPage";
import LiberacionLicenciaPage from "./pages/LiberacionLicenciaPage";
import InvitacionesPage from "./pages/InvitacionesPage";
import PromoCampaniaPage from "./pages/PromoCampaniaPage";
import ContratoPublicoPage from "./pages/ContratoPublicoPage";
import CampaniasPage from "./pages/CampaniasPage";
import SoporteTicketsPage from "./pages/SoporteTicketsPage";
import ManualesAgentePage from "./pages/ManualesAgentePage";
import AgenteConfiguracionPage from "./pages/AgenteConfiguracionPage";
import { useSupportAuth } from "./context/SupportAuthContext";

const RequireRoles = ({ roles, children }) => {
  const { authReady, hasRole } = useSupportAuth();
  if (!authReady) return null;
  if (!roles.some((r) => hasRole(r))) {
    return <div style={{ padding: 24 }}>Acceso denegado: se requiere el rol {roles.join(" o ")}.</div>;
  }
  return children;
};

const App = () => (
  <HashRouter>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/promo/:codigo" element={<PromoCampaniaPage />} />
      <Route path="/contrato/:token" element={<ContratoPublicoPage />} />

      <Route
        path="/"
        element={
          <RequireMaster>
            <MasterLayout />
          </RequireMaster>
        }
      >
        <Route index element={<Navigate to="/resumen" replace />} />
        <Route path="resumen" element={<ResumenPage />} />
        <Route path="tenants" element={<TenantsPage />} />
        <Route path="estadocuenta" element={<EstadoCuentaPage />} />
        <Route path="comunicaciones" element={<ComunicacionesPage />} />
        <Route path="campanias" element={<CampaniasPage />} />
        <Route
          path="tickets"
          element={
            <RequireRoles roles={["SA", "SOPORTE"]}>
              <SoporteTicketsPage />
            </RequireRoles>
          }
        />
        <Route
          path="invitaciones"
          element={
            <RequireRoles roles={["SA", "SOPORTE"]}>
              <InvitacionesPage />
            </RequireRoles>
          }
        />
        <Route path="grafana" element={<GrafanaPage />} />
        <Route path="bitacora" element={<BitacoraPage />} />
        <Route
          path="liberacion-licencia"
          element={
            <RequireRole rol="SA">
              <LiberacionLicenciaPage />
            </RequireRole>
          }
        />
        <Route
          path="usuarios"
          element={
            <RequireRole rol="SA">
              <UsuariosPage />
            </RequireRole>
          }
        />
        <Route
          path="manuales-agente"
          element={
            <RequireRole rol="SA">
              <ManualesAgentePage />
            </RequireRole>
          }
        />
        <Route
          path="configuracion-agente"
          element={
            <RequireRole rol="SA">
              <AgenteConfiguracionPage />
            </RequireRole>
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/resumen" replace />} />
    </Routes>
  </HashRouter>
);

export default App;
